import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { fmtDate, fmtTime, REACTIONS } from "@/lib/api";

const Totals = ({ t, locked }) => {
  const max = Math.max(1, ...Object.values(t.reactions));
  return (
    <div className="panel relative p-6" data-testid="reactions-breakdown">
      <div className="label-mono mb-4">What listeners love</div>
      <div className={locked ? "pointer-events-none select-none blur-sm" : ""}>
        {REACTIONS.map((r) => (
          <div key={r} className="mb-3 flex items-center gap-3 font-mono text-xs uppercase text-slate-400">
            <span className="w-14">{r}</span><div className="h-2 flex-1 rounded-full bg-white/10"><div className="h-full rounded-full bg-gradient-to-r from-[#00F5D4] to-[#FF2E63]" style={{ width: `${(t.reactions[r] / max) * 100}%` }} /></div><span className="w-8 text-right">{t.reactions[r]}</span>
          </div>
        ))}
      </div>
      {locked && <Upgrade />}
    </div>
  );
};

const Upgrade = () => (
  <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 rounded-[14px] bg-[#07090E]/60 text-center" data-testid="report-locked">
    <Lock className="h-5 w-5 text-[#FFB800]" />
    <p className="max-w-xs text-sm text-slate-300">Reactions and page visits are in the full report.</p>
    <Link to="/dashboard?tab=plan" className="btn-hot !px-5 !py-2 text-sm">Upgrade to Artist · €4.99</Link>
  </div>
);

export const Reports = ({ d }) => {
  const locked = d.plan.id === "free";
  return (
    <div className="space-y-6" data-testid="dash-reports">
      <Totals t={d.totals} locked={locked} />
      <div className="panel overflow-x-auto">
        <table className="w-full min-w-[720px] text-sm" data-testid="plays-table">
          <thead><tr className="border-b border-white/10 text-left font-mono text-[10px] uppercase tracking-widest text-slate-500">
            {["When", "Track", "Mode", "Listeners", "Flames", "Top reactions", "Page visits"].map((h) => <th key={h} className="p-4 font-normal">{h}</th>)}
          </tr></thead>
          <tbody>
            {d.reports.map((p) => {
              const top = Object.entries(p.reactions).filter(([, v]) => v).sort((a, b) => b[1] - a[1]).slice(0, 2);
              return (
                <tr key={p.play_id} className="border-b border-white/5" data-testid={`play-row-${p.play_id}`}>
                  <td className="p-4 font-mono text-xs text-slate-400">{fmtDate(p.start)} {fmtTime(p.start)}</td>
                  <td className="p-4 font-display font-bold">{p.title}</td>
                  <td className="p-4">{p.blind ? <span className="font-mono text-[10px] uppercase text-[#FFB800]">Blind Drop</span> : p.premiere ? <span className="font-mono text-[10px] uppercase text-[#FF2E63]">Premiere</span> : <span className="font-mono text-[10px] uppercase text-slate-500">Named</span>}</td>
                  <td className="p-4 led">{p.listeners}</td>
                  <td className="p-4 font-mono text-[#FF2E63]">{p.flames}</td>
                  <td className="p-4 font-mono text-xs uppercase text-slate-300">{locked ? <Lock className="h-3.5 w-3.5 text-slate-600" /> : top.map(([k, v]) => `${k} ${v}`).join(" · ") || "–"}</td>
                  <td className="p-4 font-mono">{locked ? <Lock className="h-3.5 w-3.5 text-slate-600" /> : p.visits}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!d.reports.length && <p className="p-10 text-center text-slate-500" data-testid="no-plays">No plays yet. Once you're approved and on air, every play shows up here — with real numbers.</p>}
      </div>
    </div>
  );
};
